module.exports = __webpack_public_path__ + "static/media/do.e31ff1fd.svg";